export const CoreConnectFileType = {
  CSV: 'CSV',
  AVRO: 'AVRO',
  NONE: null,
} as const;
export type CoreConnectFileTypeE = typeof CoreConnectFileType[keyof typeof CoreConnectFileType];

export default CoreConnectFileType;
